import {createAsyncStoragePersister} from '@tanstack/query-async-storage-persister';
import {QueryClient} from '@tanstack/react-query';
import Storage from './wrappers/Storage';

export const STALE_TIME = 60 * 1000 * 5; // 5 minutes

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      select: (result: any) => result,
    },
  },
});

export const asyncStoragePersister = createAsyncStoragePersister({
  storage: Storage,
  serialize: JSON.stringify,
  deserialize: (data) => (typeof data === 'string' ? JSON.parse(data) : data),
});

export default queryClient;
